module.exports = __webpack_public_path__ + "img/education_layout_name1.804089e3.png";